/* src/app/modules/dna-syngovia/components/dna-syngovia-healthcheck-summary/dna-syngovia-healthcheck-summary.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}
sh-text {
  width: fit-content;
  white-space: nowrap;
}
.summary-container {
  min-height: 3.25rem;
  max-height: fit-content;
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 1.5rem 0 1rem;
  background: var(--white, #FFF);
}
.summary-container .summary-message {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.summary-container .summary-message sh-text {
  flex-grow: 1;
}
.summary-container .summary-message .summary-description {
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.75rem;
}
.score-container {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.score-date {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.score-date sh-text:last-of-type {
  white-space: nowrap;
}
.score {
  text-align: right;
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 3rem;
  color: var(--Colors-UI-1-UI-1, #000);
}
.severity {
  border-bottom: 0.25rem solid;
}
.severity--low {
  border-bottom-color: rgb(var(--functional-green, #009A38));
}
.severity--medium {
  border-bottom-color: rgb(var(--functional-yellow, #FFD200));
}
.severity--high {
  border-bottom-color: rgb(var(--functional-red, #E7001D));
}
/*# sourceMappingURL=dna-syngovia-healthcheck-summary.component.css.map */
